<script lang="ts">
  import { getHelpComponent } from '$lib/help'
  import Reference from '../Reference.svelte'

  let { data } = $props()

  let Doc = $derived(getHelpComponent(data.node.full_slug))
</script>

<h2 class="@heading +large">{data.node.title}</h2>

<p class="@paragraph +xlarge +fill">
  {data.node.teaser}
</p>

{#if Doc}
  <hr class="@spacer +small +line" />

  <div class="richtext">
    <Doc />
  </div>
{/if}

<hr class="@spacer" />

{#if data.next}
  <Reference supheading="Up next" post={data.next} />
{/if}

<style lang="postcss">
  .richtext {
    font-size: fluid(1rem, 1.125rem);
  }
</style>
